import CoverPage, {
  CoverPageFormData
} from "@saleor/cover/components/CoverPage";
import { useCoverCreateMutation } from "@saleor/cover/mutations";
import {
  CoverAddUrlQueryParams,
  coverListUrl,
  coverUrl
} from "@saleor/cover/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import React from "react";
import { useIntl } from "react-intl";

import { CoverValueTypeEnum } from "../CoversDetails/CoversDetails";

interface CoverDetailsProps {
  params: CoverAddUrlQueryParams;
}

const CoverDetails: React.FC<CoverDetailsProps> = ({}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const [coverCreate, coverCreateOpts] = useCoverCreateMutation({
    onCompleted: data => {
      if (data.coverCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Successfully created cover"
          })
        });
        navigate(coverUrl(data.coverCreate.cover.id));
      }
    }
  });

  const handleSubmit = async (data: CoverPageFormData) => {
    const input = {
      ...data,
      coverType: CoverValueTypeEnum(data.coverType)
    };
    const result = await coverCreate({
      variables: {
        input
      }
    });
    return result.data.coverCreate?.cover?.id || null;
  };
  return (
    <>
      <CoverPage
        cover={null}
        disabled={coverCreateOpts.loading}
        errors={coverCreateOpts.data?.coverCreate.errors || []}
        onBack={() => navigate(coverListUrl())}
        onDelete={undefined}
        onSubmit={handleSubmit}
        saveButtonBarState={coverCreateOpts.status}
        isNew={true}
        onNextPage={null}
        onPreviousPage={null}
        toggle={null}
        toggleAll={null}
        isChecked={null}
        selected={null}
        categoryListToolbar={null}
        productListToolbar={null}
      ></CoverPage>
    </>
  );
};

export default CoverDetails;
